import { BranchDetailPage } from '@/features/branch/pages/BranchDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/branch/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["branch.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BranchDetailPage,
})
